import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import DMS from "../Pages/DMS/DMS";
import Loader from "react-spinner-loader";
import navLinks from "../JsonData/navLinksData";
import { planning_routes_regs, lms_routes_regs, my_sop_mgmnt_regs, dmsdashboard, my_report_mgmnt_regs, resource_routes_regs, my_tasks_regs, region_routes_regs, agency_routes_regs, masterdatamgmnt_routes_regs, resource_entity_routes_regs, facility_routes_regs, masterresource_routes_regs, my_gis_mgmnt_regs, form_viewers, reportsMap, situal_awaren, resourceallocation_routes_regs, housing_grievance, disaster_ack, alert_disa, active_panel, pre_disaster_routes, grievance_routes } from "./DMSRoutes";
import RegistrationManagement from "../Pages/DMS/RegistrationManagement/RegistrationManagement";
import RegionManagement from "../Pages/DMS/RegionManagement/RegionManagement";
import AgencyManagement from "../Pages/DMS/AgencyManagement/AgencyManagement";
import TaskManagement from "../Pages/DMS/TaskManagement/TaskManagement";
import ViewTaskDetail from "../Pages/DMS/TaskManagement/ViewTaskDetail/ViewTaskDetail";
import UserManagement from "../Pages/DMS/UserManagement/UserManagement";
import DailyHeatWaveForm from "../Pages/DMS/Dashboard/DailyHeatWaveReport/DailyHeatWaveForm";
import PrivateRoute from "./PrivateRoute";
import ResourceManagement from "../Pages/DMS/ResourceManagement/ResourceManagement";
import MasterDataManagement from "../Pages/DMS/MasterDataManagement/MasterDataManagement";
import FacilityManagement from "../Pages/DMS/FacilityManagement/FacilityManagement";
import MasterResourceManagement from "../Pages/DMS/MasterResourceManagement/MasterResourceManagement";
import MyTaskListManagement from "../Pages/DMS/MyTaskListManagement/MyTaskListManagement";
import GisManagement from "../Pages/DMS/GisManagement/GisManagement";
import ReportManagement from "../Pages/DMS/ReportManagement/ReportManagement";
import FormViewer from "../Pages/DMS/ReportManagement/FormViewer";
import FormRenderer from "../Pages/DMS/ReportManagement/FormRenderer";
import {
  getData
} from "../Services/Services";
import {
  getStoredFormTemplates, findPermissionsByUser
} from "../Services/EndPoints";
import FormViewerForm from "../Pages/DMS/ReportManagement/FormViewerForm";
import SOPExecutionManagement from "../Pages/DMS/GisManagement/SOPExecutionManagement";
import GISResourceManagement from "../Pages/DMS/GisManagement/GISResourceManagement";
import ReportBuilderManagement from "../Pages/DMS/GisManagement/ReportBuilderManagement";
import FormBuilder from "../Pages/DMS/ReportManagement/FormBuilder";
import SoPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import CreateSOP from "../Pages/DMS/SOPManagement/CreateSOP/CreateSOP";
import ExecuteSops from "../Pages/DMS/SOPManagement/ExecuteSops";
import SopInstance from "../Pages/DMS/SOPManagement/SopInstance/SopInstance";
import ViewSopInstance from "../Pages/DMS/SOPManagement/SopInstance/ViewSopInstance/ViewSopInstance";
import CreateTask from "../Pages/DMS/TaskManagement/CreateTask/CreateTask";
import ViewSOP from "../Pages/DMS/SOPManagement/ViewSOP/ViewSOP";
import SopsInstance from "../Pages/DMS/SOPManagement/SopsInstance/SopsInstance";
import ViewedSopInstance from "../Pages/DMS/SOPManagement/ViewedSopInstance/ViewedSopInstance/ViewedSopInstance";
import IncidentCategoryMatrix from "../Pages/DMS/SOPManagement/IncidentCategoryMatrix/IncidentCategoryMatrix";
import IncidentCategoryMatrixForm from "../Pages/DMS/SOPManagement/IncidentCategoryMatrix/IncidentCategoryMatrixForm";
import CreateAlert from "../Pages/DMS/DisasterNotification/CreateAlert/CreateAlert";
import CapAlerts from "../Pages/DMS/DisasterNotification/CapAlerts/CapAlerts";
import ContactManagement from "../Pages/DMS/ContactManagement/ContactManagement";
import DeploymentList from "../Pages/DMS/GisManagement/DeploymentList";
import { useKeycloak } from "@react-keycloak/web";
import UserTaskManagement from "../Pages/DMS/UserTaskManagement/UserTaskManagement";
import UserTaskForm from "../Pages/DMS/UserTaskManagement/UserTaskForm/UserTaskForm";
import ViewUserTask from "../Pages/DMS/UserTaskManagement/ViewUserTask/ViewUserTask";
import AnimalShelter from "../Pages/DMS/Dashboard/AnimalShelter/AnimalShelter";
import UserProfile from "../Pages/UserProfile/UserProfile";
import StateDashboard from "../Pages/DMS/Dashboard/StateDashboard/StateDashboard";
import DMSDashboard from "../Pages/DMS/Dashboard/DMSDashboard/DMSDashboard";
import RTIncidentDashboard from "../Pages/DMS/GisManagement/RTIncidentDashboard";
import HumanLossForm from "../Pages/DMS/Dashboard/HumanLossDetails/HumanLossForm/HumanLossForm";
import DailyColdWaveForm from "../Pages/DMS/Dashboard/DailyColdWaveReport/DailyColdWaveForm";
import DailyCloudBurstForm from "../Pages/DMS/Dashboard/DailyCloudBurstReport/DailyCloudBurstForm";
import DailyAffectedFloodReport from "../Pages/DMS/Dashboard/DailyAffectedFloodReport/DailyAffectedFloodReport";
import HumanLossReport from "../Pages/DMS/Dashboard/HumanLossReport/HumanLossReport";
import MainDashboard from "../Pages/DMS/Dashboard/MainDashboard";
import IncidentManagementt from "../Pages/DMS/GisincidentManagement/IncidentManagementt";
import ViewIncident from "../Pages/DMS/GisincidentManagement/ViewIncident/ViewIncident";
import GisMapview from "../Pages/DMS/GisincidentManagement/GisMapview";
import CreateIncident from "../Pages/DMS/Incidentmanagement/CreateIncident";
import CreateEvent from "../Pages/DMS/Incidentmanagement/CreateEvent";
import ResourceAssignAndDeploy from "../Pages/DMS/ResponseRelief/ResourceAssignAndDeploy";
import DeploymentResource from "../Pages/DMS/ResponseRelief/DeploymentResource";
import Chatbot from "../Pages/DMS/Chatbot/Chatbot";
import GrievanceMainForm from "../Pages/DMS/RentalGrievance/GrievanceMainForm";
import GrievanceList from "../Pages/DMS/RentalGrievance/GrievanceList";
import GrievanceViewTickets from "../Pages/DMS/RentalGrievance/GrievanceViewTickets/GrievanceViewTickets";
import GrievanceView from "../Pages/DMS/RentalGrievance/GrievanceView";
import AccidentViewerHeader from "../Pages/DMS/DisasterNotification/AccidentViewerHeader";
import AccidentsHistory from "../Pages/DMS/DisasterNotification/AccidentsHistoryMain";
import ActivePanelHeader from "../Pages/DMS/ActivePanel/ActivePanelHeader";
import FireCommunityKitchenForm from "../Pages/DMS/Dashboard/FireCommunityKitchenReport/FireCommunityKitchenForm";
import DailyAvalancheForm from "../Pages/DMS/Dashboard/DailyAvalancheReport/DailyAvalancheForm";
import DailyGlofForm from "../Pages/DMS/Dashboard/DailyGlofReport/DailyGlofForm";
import DailyEarthquakeForm from "../Pages/DMS/Dashboard/DailyEarthquakeReport/DailyEarthquakeForm";
import HumanLossDashboard from "../Pages/DMS/Dashboard/HumanLossDashboard/HumanLossDashboard";
import ColdWaveDashboard from "../Pages/DMS/Dashboard/CodlWaveDashboard/ColdWaveDashboard";
import FireDashboard from "../Pages/DMS/Dashboard/FireDashboard/FireDashboard";
import HeatWaveDashboards from "../Pages/DMS/Dashboard/HeatWaveDashboard/HeatWaveDashboard";
import CloudBurstDashboard from "../Pages/DMS/Dashboard/CloudBrust/CloudBrustDashboard";
import AvalancheDashboard from "../Pages/DMS/Dashboard/AvalancheDAshboard/AvalancheDashboard";
import GlofDashboard from "../Pages/DMS/Dashboard/GolfDashboard/GlofDashboard";
import UserActivityManagement from "../Pages/DMS/UserManagement/UserActivity/UserActivityManagement";
import GrievanceMain from "../Pages/DMS/HelpdeskOrGrievance/GrievanceMain";

const Router = () => {
  const [formViewerLinks, setFormViewerLinks] = useState([]);
  const [permissionArr, setPermissionArr] = useState(null);
  const [pemrssionLoaded, isPermissionLoaded] = useState(false);
  const [loader, setLoader] = useState(false);
  const { keycloak, initialized } = useKeycloak()

  useEffect(() => {
    if (keycloak.authenticated) {
      getPermissionList();
      addReportMenu();
    }
  }, [keycloak.authenticated])

  const getPermissionList = async () => {
    var permissionArr = await getData(findPermissionsByUser);
    setPermissionArr(permissionArr)
  };

  // ─── Helper function to map route paths to components ─────────────────────
  const getIndexComponent = (routePath) => {
    const routeMap = {
      // Dashboards
      "main-dashboard": <MainDashboard />,
      "post-disaster-analysis": <MainDashboard />,
      "dmsdashboard": <MainDashboard />,
      "incidentdashboard": <RTIncidentDashboard />,

      // Reports
      "affected-floodreport": <DailyAffectedFloodReport />,
      "partiallyaffected-floodreport": <DailyAffectedFloodReport />,
      "dailyfloodreport": <DailyAffectedFloodReport />,
      "reporting-status": <ReportManagement />,
      "affected-report": <DailyAffectedFloodReport />,
      "partiallyaffected-report": <DailyAffectedFloodReport />,
      "statefloodreport": <DailyAffectedFloodReport />,
      "misdist-report": <ReportManagement />,
      "human-loss-report": <HumanLossReport />,
      "mis-human-loss-report": <ReportManagement />,
      "fireincident-report": <DailyAffectedFloodReport />,
      "mis-fire-report": <ReportManagement />,
      "fire-community-kitchen-report": <FireCommunityKitchenForm />,
      "fire-wave-reporting-status": <ReportManagement />,
      "heat-wave-report": <DailyHeatWaveForm />,
      "heat-wave-misreport": <ReportManagement />,
      "heat-wave-reporting-status": <ReportManagement />,
      "dr-cold-wave": <DailyColdWaveForm />,
      "misdist-coldwave-report": <ReportManagement />,
      "cold-wave-reporting-status": <ReportManagement />,
      "community-kitchen": <AnimalShelter />,
      "fl-camp": <AnimalShelter />,
      "animal-shelter": <AnimalShelter />,

      // My Tasks
      "my-tasks": <MyTaskListManagement />,
      "view-usertask": <UserTaskManagement />,

      // Administrative Activities
      "masterdata-table": <MasterDataManagement />,
      "region-list": <RegionManagement />,
      "agency-list": <AgencyManagement />,
      "users": <UserManagement />,
      "roles": <UserManagement />,
      "master-resource": <MasterResourceManagement />,
      "user-activity": <UserManagement />,

      // Planning
      "view-contact": <ContactManagement />,
      "facility-mgmt": <FacilityManagement />,
      "resource-list": <ResourceManagement />,
      "view-sop": <SoPManagement />,
      "view-task": <TaskManagement />,
      "create-sop": <SoPManagement />,
      "execute-sops": <SOPExecutionManagement />,
      "Sop-instance-list": <SOPExecutionManagement />,

      // Situational Awareness/GIS
      "situation-awareness": <GisMapview />,
      "incident-management": <IncidentManagementt />,
      "create-event": <CreateEvent />,
      "create-incidentpage": <CreateIncident />,

      // Response & Relief
      "resource-assign-list": <ResourceAssignAndDeploy />,
      "deployment-resource": <DeploymentResource />,

      // Grievance (Housing Helpdesk)
      "grievance-rental-tickets": <GrievanceList />,
      "grievance-rental": <GrievanceMainForm />,
      "grievance-rental-view-tickets": <GrievanceView />,

      // Other routes
      "gismanagement": <GisManagement />,
      "sopexecution": <SOPExecutionManagement />,
      "resources": <GISResourceManagement />,
      "reportmanagement": <ReportManagement />,
      "response-relief": <DeploymentList />,
      "reportbuilder": <ReportBuilderManagement />,
      "static": <MyTaskListManagement />,
      "userProfile": <UserProfile />,
      "Chatbot": <Chatbot />,
      "Disaster-Acknowladgement": <AccidentViewerHeader />,
      "Disaster-acknowledgereport": <AccidentsHistory />,
      "Active-panellist": <ActivePanelHeader />,

      // Form routes
      "human-loss/registration-form": <HumanLossForm />,
      "daily-cold-wave/registration-form": <DailyColdWaveForm />,
      "daily-cloud-burst/registration-form": <DailyCloudBurstForm />,
      "daily-avalanche/registration-form": <DailyAvalancheForm />,
      "daily-glof/registration-form": <DailyGlofForm />,
      "daily-earthquake/registration-form": <DailyEarthquakeForm />,
      "daily-heat-wave/registration-form": <DailyHeatWaveForm />,
      "fire-community-kitchen/registration-form": <FireCommunityKitchenForm />,
    };

    return routeMap[routePath];
  };

  // ─── Helper: extract user's permission IDs into a Set ────────────────────────
  const getUserPermissionIds = () => {
    if (!permissionArr) return new Set();
    return new Set(permissionArr.map((p) => p.id));
  };

  const getUserRoles = () => {
    try {
      let userobjdata = JSON.parse(localStorage.getItem("user_obj_data"));
      if (!userobjdata?.tokenParsed?.resource_access?.["realm-management"]) return [];
      return userobjdata.tokenParsed.resource_access["realm-management"].roles || [];
    } catch (e) {
      return [];
    }
  };

  const getDefaultIndexComponent = () => {
    const userPermissionIds = getUserPermissionIds();
    const userRoles = getUserRoles();

    const checkAccess = (item) => {
      if (item.allowedPermissionIds && item.allowedPermissionIds.length > 0) {
        return item.allowedPermissionIds.some(id => userPermissionIds.has(id));
      }
      if (item.allowedRoles && item.allowedRoles.length > 0) {
        return item.allowedRoles.some(role => userRoles.includes(role));
      }
      return true;
    };

    const resolvePath = (childTo, parentTo) => {
      if (childTo.startsWith("../")) {
        const siblingPath = childTo.replace("../", "");
        const parentParts = parentTo.split("/");
        if (parentParts.length > 1) {
          parentParts.pop();
          return `${parentParts.join("/")}/${siblingPath}`;
        }
        return siblingPath;
      }
      if (childTo.startsWith("/")) {
        return childTo.replace(/^\//, "");
      }
      return parentTo ? `${parentTo}/${childTo}` : childTo;
    };

    const findFirstLeaf = (items, parentPath = "") => {
      for (const item of items) {
        if (checkAccess(item)) {
          const currentPath = resolvePath(item.to, parentPath);
          if (item.children && item.children.length > 0) {
            const leaf = findFirstLeaf(item.children, currentPath);
            if (leaf) return leaf;
          } else {
            return currentPath;
          }
        }
      }
      return null;
    };

    const firstAccessiblePath = findFirstLeaf(navLinks);

    if (firstAccessiblePath) {
      // Clean up multiple slashes or trailing slashes for the redirect
      const cleanPath = "/" + firstAccessiblePath.replace(/\/+/g, '/').replace(/\/$/, "");
      return <Navigate to={cleanPath} replace />;
    }

    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h3>No accessible modules found.</h3>
        <p>Please contact your administrator to assign the required permissions.</p>
      </div>
    );
  };

  // Returns the first child component under Administrative Activities
  const getAdministrativeActIndexComponent = () => {
    let componentArr = {
      "2_0": <MasterDataManagement />,
      "6_1": <RegionManagement />,
      "10_2": <AgencyManagement />,
      "37_3": <UserManagement />,
      "18_4": <MasterDataManagement />,
      "38_5": <ReportManagement />,
      "39_6": <FormBuilder />
    };
    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id == 1) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]['id'] + '_' + data[0]['menu_index']]
    }
    else {
      return null;
    }
  }

  // Returns the first child component under Administration & Planning
  const getPlanningIndexComponent = () => {
    let componentArr = {
      "22_0": <ContactManagement />,
      "34_1": <FacilityManagement />,
      "35_2": <ResourceManagement />,
      "36_3": <SoPManagement />
    };
    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id == 26) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]['id'] + '_' + data[0]['menu_index']]
    }
    else {
      return null;
    }
  }

  const addReportMenu = async () => {
    var data = await getData(getStoredFormTemplates);
    let form_viewer_links = [];
    data.forEach(function (dataElems) {
      form_viewer_links.push(
        dataElems.form_name
      );
    });
    setFormViewerLinks(form_viewer_links);
  };

  return (
    <Routes>
      {permissionArr != null && (
        <Route path="/" element={<DMS />}>

          {/* Index route */}
          <Route
            index
            element={
              <PrivateRoute>
                {getDefaultIndexComponent()}
              </PrivateRoute>
            }
          />

          <Route path="/userProfile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />

          <Route
            path="static"
            element={
              <PrivateRoute>
                <MyTaskListManagement />
              </PrivateRoute>
            }
          />

          {/* Users routes */}
          <Route path="users">
            <Route index element={<UserManagement />} />
            {lms_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>



          {/* Resource List routes */}
          <Route path="resource-list" element={<RegistrationManagement />}>
            <Route index element={<ResourceManagement />} />
            {resource_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          {/* Master Resource routes */}
          <Route path="master-resource" element={<RegistrationManagement />}>
            <Route index element={<MasterResourceManagement />} />
            {masterresource_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          {/* Section 1: Operational Dashboard */}
          <Route path="main-dashboard" element={<MainDashboard />} />

          {/* Section 3: Post Disaster Analysis - separate parent path */}
          <Route path="post-disaster-analysis" element={<RegistrationManagement />}>
            <Route index element={<MainDashboard />} />
            {dmsdashboard.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          {/* Reports routes */}
          <Route path="reports" element={<RegistrationManagement />}>
            <Route index element={<DailyAffectedFloodReport />} />
            {reportsMap.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="grievance">
            <Route index element={<GrievanceMain />} />
            {grievance_routes.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>


          {/* Report Builder */}
          <Route path="reportbuilder">
            <Route index element={<ReportBuilderManagement />} />
          </Route>

          {/* Planning routes & nested Administration routes */}
          <Route path="planning">
            <Route index element={getPlanningIndexComponent()} />
            {planning_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}

            <Route path="masterdata-table">
              <Route index element={<MasterDataManagement />} />
              {masterdatamgmnt_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="region-list">
              <Route index element={<RegionManagement />} />
              {region_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="agency-list">
              <Route index element={<AgencyManagement />} />
              {agency_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="users">
              <Route index element={<UserManagement />} />
              {lms_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="master-resource" element={<RegistrationManagement />}>
              <Route index element={<MasterResourceManagement />} />
              {masterresource_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="user-activity" element={<PrivateRoute><UserActivityManagement /></PrivateRoute>} />
            <Route path="view-contact" element={<PrivateRoute><ContactManagement /></PrivateRoute>} />

            <Route path="facility-mgmt">
              <Route index element={<FacilityManagement />} />
              {facility_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>

            <Route path="resource-list" element={<RegistrationManagement />}>
              <Route index element={<ResourceManagement />} />
              {resource_routes_regs.map(({ name, component }, i) => (
                <Route key={i} path={name} element={<PrivateRoute>{component}</PrivateRoute>} />
              ))}
            </Route>
          </Route>

          {/* Response Relief */}
          <Route path="response-relief">
            <Route index element={<DeploymentList />} />
          </Route>

          {/* SOP Execution */}
          <Route path="sopexecution">
            <Route index element={<SOPExecutionManagement />} />
          </Route>

          {/* Resources */}
          <Route path="resources">
            <Route index element={<GISResourceManagement />} />
          </Route>

          {/* DMS Dashboard */}
          <Route path="dmsdashboard">
            <Route index element={<MainDashboard />} />
            {dmsdashboard.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          {/* SECTION 2: Pre Disaster & Early Warning */}
          {/* All sub-routes nested under Disaster-acknowledgereport matching navLinksData.js */}
          <Route path="Disaster-Acknowladgement" element={<AccidentViewerHeader />}>
            <Route index element={<AccidentViewerHeader />} />
            {disaster_ack.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          <Route path="Disaster-acknowledgereport">
            <Route index element={<AccidentsHistory />} />
            <Route path="create-alert" element={<CreateAlert />} />
            <Route path="cap-alerts" element={<CapAlerts />} />

            {/* Nested Situational Awareness (GIS) with its children */}
            <Route path="situation-awareness">
              <Route index element={<GisMapview />} />
              <Route path="incident-management" element={<IncidentManagementt />} />
              <Route path="view-incident" element={<ViewIncident />} />
              <Route path="map-view" element={<GisMapview />} />
              <Route path="create-event" element={<CreateEvent />} />
              <Route path="create-incidentpage" element={<CreateIncident />} />
            </Route>

            {/* Nested SOP Management with its children */}
            <Route path="view-sop">
              <Route index element={<SoPManagement />} />
              <Route path="view-task" element={<TaskManagement />} />
              <Route path="view-taskinfo" element={<ViewTaskDetail />} />
              <Route path="create-sop" element={<CreateSOP />} />
              <Route path="execute-sops" element={<ExecuteSops />} />
              <Route path="Sop-instance-list" element={<SopInstance />} />
              <Route path="view-sop-instance" element={<ViewSopInstance />} />
              <Route path="create-task" element={<CreateTask />} />
              <Route path="view-sopinfo" element={<ViewSOP />} />
              <Route path="sops-instance" element={<SopsInstance />} />
              <Route path="viewsops-instance" element={<ViewedSopInstance />} />
              <Route path="category-matrix">
                <Route index element={<IncidentCategoryMatrix />} />
                <Route path="create" element={<IncidentCategoryMatrixForm />} />
              </Route>
            </Route>

            {/* Nested Response & Relief with its children */}
            <Route path="resource-assign-list">
              <Route index element={<ResourceAssignAndDeploy />} />
              <Route path="deployment-resource" element={<DeploymentResource />} />
            </Route>

            {/* Nested Task Management with its children */}
            <Route path="my-tasks">
              <Route index element={<MyTaskListManagement />} />
              <Route path="view-usertask" element={<UserTaskManagement />} />
              <Route path="create-usertask" element={<UserTaskForm />} />
              <Route path="usertask-view" element={<ViewUserTask />} />
            </Route>

            <Route path="Active-panellist" element={<ActivePanelHeader />} />
          </Route>

          {/* Standalone Situation Awareness route (kept for direct access) */}
          <Route path="situation-awareness">
            <Route index element={<GisMapview />} />
            <Route path="incident-management" element={<IncidentManagementt />} />
            <Route path="view-incident" element={<ViewIncident />} />
            <Route path="create-event" element={<CreateEvent />} />
            <Route path="create-incidentpage" element={<CreateIncident />} />
          </Route>

          {/* Standalone Resource Assign routes (kept for direct access) */}
          <Route path="resource-assign-list">
            <Route index element={<ResourceAssignAndDeploy />} />
            <Route path="deployment-resource" element={<DeploymentResource />} />
          </Route>

          {/* Standalone My Tasks routes (kept for direct access) */}
          <Route path="my-tasks">
            <Route index element={<MyTaskListManagement />} />
            <Route path="view-usertask" element={<UserTaskManagement />} />
            <Route path="create-usertask" element={<UserTaskForm />} />
            <Route path="usertask-view" element={<ViewUserTask />} />
          </Route>

          {/* Standalone Active Panel route (kept for direct access) */}
          <Route path="Active-panellist">
            <Route index element={<ActivePanelHeader />} />
          </Route>

          {/* Report Management */}
          <Route path="reportmanagement">
            <Route index element={<ReportManagement />} />
            {my_report_mgmnt_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          {/* Form routes */}
          <Route path="report-view/:formName">
            <Route index element={<PrivateRoute><FormViewer /></PrivateRoute>} />
          </Route>

          <Route path="create-form-view/:formName">
            <Route index element={<PrivateRoute><FormRenderer /></PrivateRoute>} />
          </Route>

          <Route path="/human-loss/registration-form">
            <Route index element={<HumanLossForm />} />
          </Route>

          <Route path="/daily-cold-wave/registration-form">
            <Route index element={<DailyColdWaveForm />} />
          </Route>

          <Route path="/daily-cloud-burst/registration-form">
            <Route index element={<DailyCloudBurstForm />} />
          </Route>

          <Route path="/daily-avalanche/registration-form">
            <Route index element={<DailyAvalancheForm />} />
          </Route>

          <Route path="/daily-glof/registration-form">
            <Route index element={<DailyGlofForm />} />
          </Route>

          <Route path="/daily-earthquake/registration-form">
            <Route index element={<DailyEarthquakeForm />} />
          </Route>

          <Route path="/daily-heat-wave/registration-form">
            <Route index element={<DailyHeatWaveForm />} />
          </Route>

          <Route path="/fire-community-kitchen/registration-form">
            <Route index element={<FireCommunityKitchenForm />} />
          </Route>

          {/* Grievance routes */}
          <Route path="grievance-rental-tickets">
            <Route index element={<GrievanceList />} />
            {housing_grievance.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>

          <Route path="/grievance-rental/grievance-rental">
            <Route index element={<GrievanceMainForm />} />
          </Route>

          <Route path="/grievance-rental/grievance-rental-view-tickets">
            <Route index element={<GrievanceView />} />
          </Route>

        </Route>
      )}
    </Routes>
  );
};

export default Router;